export default __webpack_public_path__ + "static/media/Artboard-1.e827702e.svg";